import { analytics } from '../../firebase';
import { logEvent, setUserProperties } from 'firebase/analytics';

/**
 * Logs a Firebase Analytics event if analytics is initialized
 * @param {string} eventName - The event name
 * @param {object} params - Optional event parameters
 */
export const logCustomEvent = (eventName, params = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

/**
 * Logs a page_view event to Firebase Analytics
 * @param {string} path - The current page path
 */
export const logPageView = (path) => {
  if (analytics) {
    logEvent(analytics, 'page_view', { page_path: path });
  }
};

/**
 * Sets user properties for Firebase Analytics
 * @param {object} properties - Key-value pairs of user properties
 */
export const setAnalyticsUserProperties = (properties) => {
  if (analytics && properties) {
    setUserProperties(analytics, properties);
  }
};
